var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStore2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 113,
    viewBox: "0 0 142 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.76531C0 2.58122 2.39901 0 5.35834 0H24.6484C27.0714 0 29.1187 1.73039 29.7813 4.10529C29.8594 4.31032 29.9273 4.52234 29.9843 4.74085L34.4628 21.9082H128.046C139.002 21.9082 145.671 34.8882 139.843 44.8709L120.996 77.1567C118.447 81.5232 113.991 84.1735 109.198 84.1735H49.8962C43.5486 84.1735 38.0034 79.5568 36.4104 72.9456L33.5566 61.1019L20.6248 11.5306H5.35834C2.39901 11.5306 0 8.9494 0 5.76531ZM42.1167 33.4388C40.0136 33.4388 38.4768 35.5756 39.0046 37.7661L43.9034 58.0966L47.3134 71.168L47.3274 71.2228C47.3327 71.2439 47.3379 71.2651 47.343 71.2863C47.9377 72.1217 48.8717 72.6429 49.8962 72.6429H109.198C110.304 72.6429 111.333 72.0313 111.921 71.0236L130.768 38.7379C132.113 36.4342 130.574 33.4388 128.046 33.4388H42.1167Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.488 113C110.702 113 115.74 107.579 115.74 100.893C115.74 94.2063 110.702 88.7857 104.488 88.7857C98.273 88.7857 93.2351 94.2063 93.2351 100.893C93.2351 107.579 98.273 113 104.488 113Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4434 100.893C66.4434 107.579 61.4055 113 55.1909 113C48.9763 113 43.9384 107.579 43.9384 100.893C43.9384 94.2063 48.9763 88.7857 55.1909 88.7857C61.4055 88.7857 66.4434 94.2063 66.4434 100.893Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore2);
export default __webpack_public_path__ + "static/media/store2.762695e92ec00b52be079fd79d4cd1f4.svg";
export { ForwardRef as ReactComponent };